/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AllShipmentsOverviewStats
 */
export interface AllShipmentsOverviewStats {
  /**
   *
   * @type {number}
   * @memberof AllShipmentsOverviewStats
   */
  totalShipments: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsOverviewStats
   */
  totalBooked: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsOverviewStats
   */
  conversionRate: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsOverviewStats
   */
  totalRevenue: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsOverviewStats
   */
  totalProfit: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsOverviewStats
   */
  avgMargin: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsOverviewStats
   */
  avgShipmentValue: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsOverviewStats
   */
  avgWeight: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsOverviewStats
   */
  avgDistance: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsOverviewStats
   */
  avgQuotesPerShipment: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsOverviewStats
   */
  insuranceRate: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsOverviewStats
   */
  crossBorderRate: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsOverviewStats
   */
  totalMoneyOut: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsOverviewStats
   */
  avgMoneyOutPerShipment: number;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof AllShipmentsOverviewStats
   */
  earliestQuotedAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof AllShipmentsOverviewStats
   */
  latestQuotedAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof AllShipmentsOverviewStats
   */
  earliestBookedAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof AllShipmentsOverviewStats
   */
  latestBookedAt?: OffsetDateTime | null;
}

/**
 * Check if a given object implements the AllShipmentsOverviewStats interface.
 */
export function instanceOfAllShipmentsOverviewStats(
  value: object,
): value is AllShipmentsOverviewStats {
  if (!("totalShipments" in value) || value["totalShipments"] === undefined)
    return false;
  if (!("totalBooked" in value) || value["totalBooked"] === undefined)
    return false;
  if (!("conversionRate" in value) || value["conversionRate"] === undefined)
    return false;
  if (!("totalRevenue" in value) || value["totalRevenue"] === undefined)
    return false;
  if (!("totalProfit" in value) || value["totalProfit"] === undefined)
    return false;
  if (!("avgMargin" in value) || value["avgMargin"] === undefined) return false;
  if (!("avgShipmentValue" in value) || value["avgShipmentValue"] === undefined)
    return false;
  if (!("avgWeight" in value) || value["avgWeight"] === undefined) return false;
  if (!("avgDistance" in value) || value["avgDistance"] === undefined)
    return false;
  if (
    !("avgQuotesPerShipment" in value) ||
    value["avgQuotesPerShipment"] === undefined
  )
    return false;
  if (!("insuranceRate" in value) || value["insuranceRate"] === undefined)
    return false;
  if (!("crossBorderRate" in value) || value["crossBorderRate"] === undefined)
    return false;
  if (!("totalMoneyOut" in value) || value["totalMoneyOut"] === undefined)
    return false;
  if (
    !("avgMoneyOutPerShipment" in value) ||
    value["avgMoneyOutPerShipment"] === undefined
  )
    return false;
  return true;
}

export function AllShipmentsOverviewStatsFromJSON(
  json: any,
): AllShipmentsOverviewStats {
  return AllShipmentsOverviewStatsFromJSONTyped(json, false);
}

export function AllShipmentsOverviewStatsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsOverviewStats {
  if (json == null) {
    return json;
  }
  return {
    totalShipments: json["totalShipments"],
    totalBooked: json["totalBooked"],
    conversionRate: json["conversionRate"],
    totalRevenue: json["totalRevenue"],
    totalProfit: json["totalProfit"],
    avgMargin: json["avgMargin"],
    avgShipmentValue: json["avgShipmentValue"],
    avgWeight: json["avgWeight"],
    avgDistance: json["avgDistance"],
    avgQuotesPerShipment: json["avgQuotesPerShipment"],
    insuranceRate: json["insuranceRate"],
    crossBorderRate: json["crossBorderRate"],
    totalMoneyOut: json["totalMoneyOut"],
    avgMoneyOutPerShipment: json["avgMoneyOutPerShipment"],
    earliestQuotedAt:
      json["earliestQuotedAt"] == null ? undefined : json["earliestQuotedAt"],
    latestQuotedAt:
      json["latestQuotedAt"] == null ? undefined : json["latestQuotedAt"],
    earliestBookedAt:
      json["earliestBookedAt"] == null ? undefined : json["earliestBookedAt"],
    latestBookedAt:
      json["latestBookedAt"] == null ? undefined : json["latestBookedAt"],
  };
}

export function AllShipmentsOverviewStatsToJSON(
  json: any,
): AllShipmentsOverviewStats {
  return AllShipmentsOverviewStatsToJSONTyped(json, false);
}

export function AllShipmentsOverviewStatsToJSONTyped(
  value?: AllShipmentsOverviewStats | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    totalShipments: value["totalShipments"],
    totalBooked: value["totalBooked"],
    conversionRate: value["conversionRate"],
    totalRevenue: value["totalRevenue"],
    totalProfit: value["totalProfit"],
    avgMargin: value["avgMargin"],
    avgShipmentValue: value["avgShipmentValue"],
    avgWeight: value["avgWeight"],
    avgDistance: value["avgDistance"],
    avgQuotesPerShipment: value["avgQuotesPerShipment"],
    insuranceRate: value["insuranceRate"],
    crossBorderRate: value["crossBorderRate"],
    totalMoneyOut: value["totalMoneyOut"],
    avgMoneyOutPerShipment: value["avgMoneyOutPerShipment"],
    earliestQuotedAt: value["earliestQuotedAt"],
    latestQuotedAt: value["latestQuotedAt"],
    earliestBookedAt: value["earliestBookedAt"],
    latestBookedAt: value["latestBookedAt"],
  };
}
